import _ from "lodash";
import AutocompleteProps from "./AutocompleteProps";
import { notNullOrUndefinedOrBlank } from "@/utility/functions";

export default {
  mixins: [AutocompleteProps],
  props: {
    messages: { type: String, default: "" }
  },
  data() {
    return {
      items: [],
      loading: false,
      search: "",
      // tutaj bo debounce jest funkcja strzalkowa
      handleSearchDebounced: _.debounce(async function() {
        await this.handleSearch();
      }, this.searchDebounceTime)
    };
  },
  async mounted() {
    if (this.preloadAllOptions) {
      await this.loadItems("", this.queryParam);
    } else {
      await this.handleInitialValue();
    }
  },
  computed: {
    prependInnerIcon() {
      return notNullOrUndefinedOrBlank(this.rules) && this.rules.includes("required")
        ? "mdi-asterisk"
        : "";
    },
    showPlaceholder() {
      return this.disabled ? "" : this.placeholder;
    }
  },
  methods: {
    async handleSearch() {
      if (notNullOrUndefinedOrBlank(this.search)) {
        await this.loadItems(this.search, this.queryParam);
      }
    },
    async handleInitialValue() {
      if (this.handleInitialValueAllowed) {
        const initialQueryParam = this.buildInitialValueQueryParam();
        await this.loadItems("", initialQueryParam);
      }
    },
    async handleQueryParam() {
      const emptyValue = this.multiple ? [] : null;
      this.$emit("input", emptyValue);
      if (this.preloadAllOptions) {
        await this.loadItems(this.search, this.queryParam);
      } else {
        this.items = [];
      }
    }
  },
  watch: {
    search: {
      async handler() {
        await this.handleSearchDebounced();
      }
    },
    queryParam: {
      async handler() {
        await this.handleQueryParam();
      }
    },
    value: {
      handler() {
        this.$emit("input", this.value);
        if (this.returnObject === false) {
          this.emitInputObject();
        }
      }
    }
  }
};
